var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full box"},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("占位")]),_c('el-button',{attrs:{"type":"success"}},[_vm._v("占位")]),_c('el-button',{attrs:{"type":"info"}},[_vm._v("占位")]),_c('el-button',{attrs:{"type":"warning"}},[_vm._v("占位")]),_c('el-button',{attrs:{"type":"danger"}},[_vm._v("占位")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }